import { Stack, SxProps } from '@mui/material';
import React from 'react';

import { HeaderButtonList as HeaderButtonListModel } from '../../../models';

export interface HeaderButtonListProps {
  node: HeaderButtonListModel;
  children: React.ReactNode;
  sx?: SxProps;
}

// TODO: The UL/LI here are only for SEO, see the discussion in SPKDE-11730
// TODO: remove as soon as we want to optimize DOM nodes.
export const HeaderButtonList: React.FunctionComponent<HeaderButtonListProps> = ({ node, children, sx }) => {
  return (
    <Stack
      component="ul"
      m={0}
      p={0}
      gap={{ xs: 2, md: 3 }}
      direction="row"
      sx={{ ...sx, listStyle: 'none' }}
      id={`${node.__component}.${node.id}`}
      alignItems="center"
    >
      {children}
    </Stack>
  );
};
